import Form from "../../../../components/forms/index"
import { useEffect, useState } from "react"
import { SuccessNotify, FailedNotify } from "../../../../constants/tostify"
import { useNavigate, useParams } from "react-router-dom"
import { useSelector } from "react-redux"
import Loader from "../../../../components/Loader"
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import {
  useGetShopByIdQuery,
  useUpdateShopMutation,
  useGetShopCategoriesQuery,
} from "../../../../features/shop/shopApiSlice";

const NewItemsUpdate = () => {
  const navigate = useNavigate();
  const authUser = useSelector((state) => state.auth?.user);
  const persistedUser = useSelector((state) => state.user?.name);
  const currentUser = authUser || persistedUser;
  const [displayimg, setDisplayimg] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isloading, setIsloading] = useState(false);
  const [shopCategoryone, setShopCategoryone] = useState([]);

  const [selectshop, setSelectshop] = useState({
    shopCategory: ""
  });

  const Shopdatas = (e) => {
    setSelectshop((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };
  const categoryName = selectshop?.shopCategory[1];
  const categoryid = selectshop?.shopCategory[0];

  localStorage.setItem('mycategory', categoryName);

  const { id } = useParams();

  const { data: shopResponse, isFetching: isShopLoading } = useGetShopByIdQuery(id, {
    skip: !id,
  });
  const { data: categoryResponse } = useGetShopCategoriesQuery({
    type: "retailerShop",
    parentCategory: "",
  });
  const [updateShop, { isLoading: isUpdating }] = useUpdateShopMutation();

  const normalizeImageItem = (item) => {
    if (!item) return null;
    if (typeof item === "string") return item.trim();
    if (item.url) return item.url;
    if (item.image) return item.image;
    return String(item).trim();
  };

  const normalizeImages = (imageData) => {
    if (!imageData) return [];
    if (Array.isArray(imageData)) {
      return imageData
        .map(normalizeImageItem)
        .filter((src) => src);
    }
    const normalized = normalizeImageItem(imageData);
    return normalized ? [normalized] : [];
  };

  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });

      const images = normalizeImages(abc);
      setCreateShop((createShop) => ({
        ...createShop,
        image: images,
      }));
      setDisplayimg(images);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });
  const [createShop, setCreateShop] = useState({
    userid: currentUser?._id || currentUser?.id || "",
    shopname: "",
    shopaddress: "",
    shoplicense: "",
    contact: "",
    image: [],
    shopCategory: categoryid,
    marketPlace: "",
    businessType: "retailerShop",
    description: "",
    status: true,
  });

  useEffect(() => {
    if (categoryResponse?.data?.Category) {
      setShopCategoryone(categoryResponse.data.Category);
    }
  }, [categoryResponse]);

  useEffect(() => {
    if (shopResponse?.data?.Shop) {
      const shop = shopResponse.data.Shop;
      const images = normalizeImages(shop?.image);
      setCreateShop((prev) => ({
        ...prev,
        ...shop,
        image: images,
        shopCategory: shop?.shopCategory?._id || shop?.shopCategory || prev.shopCategory,
      }));
      setDisplayimg(images);
      setIsloading(false);
    }
  }, [shopResponse]);

  const UpdateShop = async (e) => {
    e.preventDefault();
    setIsloading(true);

    try {
      const response = await updateShop({ id, data: createShop }).unwrap();
      SuccessNotify("Form Update Successfully");
      setIsloading(false);
      navigate(`/NewItem-bussines-Profile/${id}`);
    } catch (error) {
      console.error("Update failed", error);
      setIsloading(false);
      FailedNotify("Failed to Update");
    }
  };

  if (isShopLoading || isloading) {
    return <Loader heightsetting="screenHeight" />;
  }
  return (
    <Form
      title="Fill to Update New Items Shop"
      butn="Update"
      navigateTo="/NewItem-bussines-Profile"
      back="/NewItem-bussines-Profile/"
      UpdateShop={UpdateShop}
      shopCategoryone={shopCategoryone}
      createShop={createShop}
      setCreateShop={setCreateShop}
      link="/new-items-update/"
      id={id}
      getInputProps={getInputProps}
      getRootProps={getRootProps}
      displayimg={displayimg}
      setDisplayimg={setDisplayimg}
      Shopdatas={Shopdatas}
      isUploading={isUploading}           
uploadProgress={uploadProgress} 
    />
  );
};
export default NewItemsUpdate;
